// Comment score tracking constants
export const SCORE_START_EVENT = 'comments_engagement_score_started'
export const SCORE_STOP_EVENT = 'comments_engagement_score_stopped'

export const SESSION_SCORE_KEY_PREFIX = 'comments_session_score_at_start'
export const SESSION_SCORE_TIMESTAMP_KEY_PREFIX =
  'comments_session_score_started_at'

export const THRESHOLD_FOR_SCORE_INCREASE = 10
export const MAX_SESSION_AGE_MS = 60 * 60 * 1000 // 1 hour

// Comment reply tracking constants
export const REPLY_TRACKING_START_EVENT = 'comments_reply_tracking_started'
export const REPLY_TRACKING_STOP_EVENT = 'comments_reply_tracking_stopped'
export const REPLY_COUNT_INCREASED_EVENT = 'comments_reply_count_increased'

export const SESSION_REPLY_COUNT_KEY_PREFIX = 'comments_session_reply_count'
export const SESSION_REPLY_TIMESTAMP_KEY_PREFIX =
  'comments_session_reply_started_at'

export const THRESHOLD_FOR_MANY_REPLIES = 20
